import { WINDOW_SIZE } from '@/constants/window-size';
import { getHSize, getSize } from '@/utils/size';
import { useCallback, useMemo } from 'react';
import { useOrientation } from './useOrientation';

export const useScaleSize = () => {
    const { isHorizontal } = useOrientation();

    const baseWidth = useMemo(() => {
        if (isHorizontal) {
            return WINDOW_SIZE.HORIZONTAL.WIDTH;
        }
        return WINDOW_SIZE.VERTICAL.WIDTH;
    }, [isHorizontal]);

    const baseHeight = useMemo(() => {
        if (isHorizontal) {
            return WINDOW_SIZE.HORIZONTAL.HEIGHT;
        }
        return WINDOW_SIZE.VERTICAL.HEIGHT;
    }, [isHorizontal]);

    const scaleWidth = useCallback(
        (width?: number) => {
            return getSize(width ?? 0, baseWidth);
        },
        [baseWidth]
    );
    const scaleHeight = useCallback(
        (height?: number) => {
            return getHSize(height ?? 0, baseHeight);
        },
        [baseHeight]
    );

    return { baseWidth, baseHeight, scaleWidth, scaleHeight };
};
